import { render, staticRenderFns } from "./breadcrumb-item.vue?vue&type=template&id=5453bf40"
import script from "./breadcrumb-item.vue?vue&type=script&lang=js"
export * from "./breadcrumb-item.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb-item.vue?vue&type=style&index=0&id=5453bf40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports